import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from "../axiosService/apiCall";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Papa from "papaparse";




const rankColors = ["golden", "silver", "platinum", "sandle", "pink", "red", "black", "gray", "grays", "sandle"];

function Rewardranking() {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");


    const getUserDetails = async () => {
        try {
            let response = await makeApiRequest({ url: `getTopRewardRankers`, method: 'GET' });
            if (response.status === true) {
                setData(response.rankers);
            } else {
                setData([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };

    useEffect(() => {
        getUserDetails();
    }, []);

    const rankColorMap = {};
    let colorIndex = 0;

    data.forEach(user => {
        if (!rankColorMap[user.rank]) {
            rankColorMap[user.rank] = rankColors[colorIndex % rankColors.length];
            colorIndex++;
        }
    });

    const filteredData = data.filter(row =>
        row.userDetails.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (row.userDetails.PersonalDetails?.FirstName || "User").toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Pagination-related calculations
    const startIndex = (currentPage - 1) * perPage;
    const currentPageData = filteredData.slice(startIndex, startIndex + perPage);

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => startIndex + index + 1, // Ensure continuous numbering
            sortable: false
        },
        {
            name: 'Email', width: "350px"
            , selector: row => row.userDetails.email, sortable: true
        },
        { name: 'Name', selector: row => row.userDetails.PersonalDetails?.FirstName || "--", sortable: true },
        { name: 'Staked Amount', width: "150px", selector: row => row?.totalStakeAmount || 0, sortable: true },
        { name: 'Total Reward', selector: row => row.TotalReward, sortable: true },
        {
            name: 'Rank',
            selector: row => row.rank,
            sortable: true,
            cell: row => (
                <div className="d-flex align-items-center gap-3">
                    <button className={rankColorMap[row.rank]}>{row.rank} Rank</button>
                </div>
            )
        },
    ];


    const downloadCSV = () => {
        const csvHeaders = ["S.No", "Email", "Name", "Staked Amount", "Total Reward", "Rank"];
        const csvData = filteredData.map((row, index) => ({
            "S.No": index + 1,
            "Email": row.userDetails.email,
            "Name": row.userDetails.PersonalDetails?.FirstName || "User",
            "Staked Amount": row.totalStakeAmount || 0,
            "Total Reward": row.TotalReward,
            "Rank": row.rank
        }));
    
        const csv = Papa.unparse({
            fields: csvHeaders,
            data: csvData
        });
    
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "User_Rewards_Report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    

    return (
        <div className='App'>
            <div className='container'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user text-center ms-lg-0">User Rewards</h3>
                                <button className="btn btn-primary" onClick={downloadCSV}>
                                    Download CSV
                                </button>
                            </div>
                            <div className='row'>
                                <div className='col-lg-5'>
                                    <input
                                        type="text"
                                        placeholder="Search by Email or Name"
                                        className='mb-4 form-control form-search'
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='custom-datascroll'>
                                        <DataTable
                                            columns={columns}
                                            data={currentPageData}
                                            theme="solarized"
                                            defaultSortAsc={true}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={filteredData.length}
                                            paginationPerPage={perPage}
                                            onChangePage={(page) => setCurrentPage(page)}
                                            onChangeRowsPerPage={(newPerPage, page) => {
                                                setPerPage(newPerPage);
                                                setCurrentPage(page);
                                            }}
                                            highlightOnHover
                                            dense
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Rewardranking;